export let notes = [
    {
        title: "How to eat",
        text: "You can eat the chicken with lettuce wraps or with white rice"
    },
    {
        title: "Fried Rice with leftovers",
        text: "If you have leftovers in the pan, you can make fried rice! Heat pan to medium heat. Then, add 1 cup of rice to the pan. Mix together and add roasted seaweed, soy sauce, sesame oil, and sesame seeds. Mix in some kimchi too for a great acidic flavor contrast."
    }
]